// extracted by mini-css-extract-plugin
export default {"bulkActionsView":"styles_bulkActionsView__RPSbp","bulkActionsContainer":"styles_bulkActionsContainer__KAYR3"};